import React from "react";
import { Form, Input } from "antd";
const SKUItemsTable = ({
  offerSKU,
  handleBundleDiscountChange,
  handleBundleRuleChange
}) => {
  if (!offerSKU.items?.length) {
    return null;
  }

  return (
    <>
      <div className="d-flex justify-content-between">
        <h6 className="mt-3">
          Marketing Dependent SKUs in {offerSKU.skuCode}:
        </h6>
      </div>
      <hr />
      <div className="table-responsive small-font">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Marketing Dependent SKU</th>
              <th>Item Variation SKU</th>
              <th>Category</th>
              <th>Unit Description</th>
              <th>Qty</th>
              <th>Qty Detailed</th>
              <th>Description</th>
              <th>Price</th>
              <th>Discount</th>
              <th>Price to Pay</th>
              <th>Optional</th>
              <th>Rules</th>
            </tr>
          </thead>
          <tbody>
            {offerSKU.items.map((item) => (
              <tr key={item.id}>
                <td>{item.dependent_sku}</td>
                <td>{item.variation_code}</td>
                <td>{item.category_name}</td>
                <td>{item.unit_description}</td>
                <td>{item.qty}</td>
                <td>{item.qtyDetailed}</td>
                <td>{item.description}</td>
                <td>{item.originalPrice}</td>
                <td>{item.discount}</td>
                <td>{item.finalPrice}</td>
                <td>{item.optional}</td>
                <td>{item.rule}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="row mt-3">
        <div className="col-md-4">
          <Form.Item label="Total Bundle Price">
            <Input disabled value={offerSKU.total_bundle_price} />
          </Form.Item>
        </div>
        <div className="col-md-4">
          <Form.Item label="Bundle Discount">
            <Input
              type="number"
              value={offerSKU.bundle_discount}
              onChange={handleBundleDiscountChange}
            />
          </Form.Item>
        </div>
        <div className="col-md-4">
          <Form.Item label="Bundle Price to Pay">
            <Input disabled value={offerSKU.bundle_price_to_pay} />
          </Form.Item>
        </div>
        <div className="col-md-12 mt-2">
          <Form.Item label="Bundle Rule">
            <Input.TextArea
              value={offerSKU.bundle_rule}
              placeholder="Enter bundle rule"
              onChange={handleBundleRuleChange}
            />
          </Form.Item>
        </div>
      </div>
    </>
  );
};

export default SKUItemsTable;
